import React, { useEffect, useState } from "react";
import { Modal, Text, View } from "react-native";
import { FormattedMessage } from "react-intl";

import HeaderTabs from "../../components/HeaderTabs";
import ModalSuccess from "../../components/ModalSuccess";
import GoBackButton from "../../components/GoBackButton";

import styles from "./styles";

const ReportIncome = () => {
  const [itemsYears, setItemsYears] = useState([]);
  const [year, setYear] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    var items = [];
    var initialYear = new Date().getFullYear();
    for (let i = initialYear; i > 1980; i--) {
      items.push({ label: i.toString(), value: i });
    }
    setItemsYears(items);
  }, []);

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="reportIncome.InformeRendimentos" />}
      />
      <View style={styles.content}>
        {/* <Text style={styles.title}>Selecione o ano</Text> */}

        {/* <RNPickerSelect
                    onValueChange={(value) => setYear(value)}
                    placeholder={{
                        label: 'Selecione um ano',
                        value: 0,
                    }}
                    items={itemsYears}
                    value={year}
                    style={{
                        inputWeb: {
                            borderRadius: 4,
                            paddingHorizontal: 10,
                            height: 40,
                            marginVertical: 10,
                            color: '#222'
                        }
                    }}
                /> */}
        <Text
          style={{
            marginTop: 20,
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormattedMessage id="reportIncome.msgSemRendimentos" />
        </Text>
        <GoBackButton />
      </View>

      {/* <View style={styles.contentBtn}>
                <TouchableOpacity>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>BAIXAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentBtnEmail}>
                <TouchableOpacity onPress={() => setModalVisible(!modalVisible)}>
                    <Text style={styles.textBtnEmail}>Enviar por e-mail</Text>
                </TouchableOpacity>
            </View> */}

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => setModalVisible((visible) => !visible)}
      >
        <FormattedMessage id="reportIncome.msgDocEnviado">
          {(text) => (
            <FormattedMessage id="reportIncome.msgSucesso">
              {(textColor) => (
                <ModalSuccess
                  handleCloseModal={() => {
                    setModalVisible(false);
                  }}
                  text={text}
                  textColor={textColor}
                  img={2}
                  positionHeader={"left"}
                />
              )}
            </FormattedMessage>
          )}
        </FormattedMessage>
      </Modal>
    </>
  );
};

export default ReportIncome;
